/** Collect named fields from a <form> into a plain object for email payloads */
export function serializeForm(form) {
	const fd = new FormData(form);
	const obj = {};
	fd.forEach((value, key) => {
		const strVal = typeof value === 'string' ? value.trim() : value;
		if (obj[key] !== undefined) {
			const prev = obj[key];
			obj[key] = Array.isArray(prev) ? [...prev, strVal] : [prev, strVal];
		} else {
			obj[key] = strVal;
		}
	});
	return obj;
}
